import React from 'react';
import source from 'images/alert.svg';

import Icon from './Icon';

const AlertIcon = ({ ...props }) => <Icon alt="alert icon" src={source} {...props} />;

export default AlertIcon;
